import { Pivot, PivotItem } from "@fluentui/react";
import * as React from "react";
import PageHeader from "../common/PageHeader";
import styles from "./SubstratePlatform.less";
import { SubstratePlatformBackend } from "./SubstratePlatformBackend";
import { WarningBanner } from "../banner/WarningBanner";
import { useGetBannersByTabAndDateQuery } from "../../hooks/useBannerQuery";

export const SubstratePlatform = () => {
    const { data: allBanners } = useGetBannersByTabAndDateQuery("SubstratePlatform");
    return (
        <div className={styles.pageHeader}>
            <PageHeader
                title="Substrate Costs (Platform Pivot)"
                description="Welcome to the Substrate Platform Cost dashboard!"
                linkText="Learn More"
                link="https://o365exchange.visualstudio.com/O365%20Core/_wiki/wikis/O365%20Core.wiki/431435/Substrate-Platform-Cost-Model" />
            {Boolean(allBanners?.length) &&
                allBanners?.map(item =>
                (
                    <WarningBanner key={item.id} bannerItem={item} />
                ))
            }
            <Pivot>
                <PivotItem headerText="Backend"><SubstratePlatformBackend /></PivotItem>
            </Pivot>
        </div>
    );
}